import React, { useState } from 'react';
import classNames from 'classnames';
import { HeartIcon, UnlimitedIcon } from 'icons';

import { useAppSelector } from 'store';

import { useGetHeartData } from 'modules/global';

import HeartModal from './heart-modal';

const HeartWrapper = ({
  box = true,
  iconSize = '21',
  heartCount
}: {
  heartCount?: number;
  box?: boolean;
  iconSize?: string;
}) => {
  const [open, setOpen] = useState(false);
  const hasPremium = useAppSelector(state => state.user.premium);
  const { heartData } = useGetHeartData();

  return (
    <>
      <div
        onClick={() => setOpen(true)}
        className={classNames('flex cursor-pointer items-center gap-1 px-2 py-1', {
          'rounded-lg border-b border-b-red-300 bg-red-50 shadow-[inset_0px_2px_4px_0px_#DDCAB761]': box
        })}
      >
        <HeartIcon size={iconSize} />
        <span className="font-medium">{hasPremium ? <UnlimitedIcon /> : heartCount || heartData?.heart_count}</span>
      </div>

      <HeartModal onClose={() => setOpen(false)} open={open} />
    </>
  );
};

export default HeartWrapper;
